import { __extends } from "tslib";
import { NodeMaterialBlock } from '../nodeMaterialBlock';
import { NodeMaterialBlockConnectionPointTypes } from '../Enums/nodeMaterialBlockConnectionPointTypes';
import { NodeMaterialBlockTargets } from '../Enums/nodeMaterialBlockTargets';
import { _TypeStore } from '../../../Misc/typeStore';
/**
 * Block used to replace a color by another one
 */
var ReplaceColorBlock = /** @class */ (function (_super) {
    __extends(ReplaceColorBlock, _super);
    /**
     * Creates a new ReplaceColorBlock
     * @param name defines the block name
     */
    function ReplaceColorBlock(name) {
        var _this = _super.call(this, name, NodeMaterialBlockTargets.Neutral) || this;
        _this.registerInput("value", NodeMaterialBlockConnectionPointTypes.AutoDetect);
        _this.registerInput("reference", NodeMaterialBlockConnectionPointTypes.AutoDetect);
        _this.registerInput("distance", NodeMaterialBlockConnectionPointTypes.Float);
        _this.registerInput("replacement", NodeMaterialBlockConnectionPointTypes.AutoDetect);
        _this.registerOutput("output", NodeMaterialBlockConnectionPointTypes.BasedOnInput);
        _this._outputs[0]._typeConnectionSource = _this._inputs[0];
        _this._linkConnectionTypes(0, 1);
        _this._linkConnectionTypes(0, 3);
        _this._inputs[0].excludedConnectionPointTypes.push(NodeMaterialBlockConnectionPointTypes.Float);
        _this._inputs[0].excludedConnectionPointTypes.push(NodeMaterialBlockConnectionPointTypes.Matrix);
        _this._inputs[1].excludedConnectionPointTypes.push(NodeMaterialBlockConnectionPointTypes.Float);
        _this._inputs[1].excludedConnectionPointTypes.push(NodeMaterialBlockConnectionPointTypes.Matrix);
        _this._inputs[3].excludedConnectionPointTypes.push(NodeMaterialBlockConnectionPointTypes.Float);
        _this._inputs[3].excludedConnectionPointTypes.push(NodeMaterialBlockConnectionPointTypes.Matrix);
        return _this;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */
    ReplaceColorBlock.prototype.getClassName = function () {
        return "ReplaceColorBlock";
    };
    Object.defineProperty(ReplaceColorBlock.prototype, "value", {
        /**
         * Gets the value input component
         */
        get: function () {
            return this._inputs[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReplaceColorBlock.prototype, "reference", {
        /**
         * Gets the reference input component
         */
        get: function () {
            return this._inputs[1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReplaceColorBlock.prototype, "distance", {
        /**
         * Gets the distance input component
         */
        get: function () {
            return this._inputs[2];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReplaceColorBlock.prototype, "replacement", {
        /**
         * Gets the replacement input component
         */
        get: function () {
            return this._inputs[3];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReplaceColorBlock.prototype, "output", {
        /**
         * Gets the output component
         */
        get: function () {
            return this._outputs[0];
        },
        enumerable: false,
        configurable: true
    });
    ReplaceColorBlock.prototype._buildBlock = function (state) {
        _super.prototype._buildBlock.call(this, state);
        var output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ";\r\n";
        state.compilationString += "if (length(" + this.value.associatedVariableName + " - " + this.reference.associatedVariableName + ") < " + this.distance.associatedVariableName + ") {\r\n";
        state.compilationString += output.associatedVariableName + " = " + this.replacement.associatedVariableName + ";\r\n";
        state.compilationString += "} else {\r\n";
        state.compilationString += output.associatedVariableName + " = " + this.value.associatedVariableName + ";\r\n";
        state.compilationString += "}\r\n";
        return this;
    };
    return ReplaceColorBlock;
}(NodeMaterialBlock));
export { ReplaceColorBlock };
_TypeStore.RegisteredTypes["BABYLON.ReplaceColorBlock"] = ReplaceColorBlock;
//# sourceMappingURL=replaceColorBlock.js.map